/**
 * Created by Daniel on 1/13/2020
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../../widgets/widgets.module';
import { TaskListItemModule } from '../task-list-item/task-list-item.module';
import { TaskListComponent } from './task-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TaskMenuModule } from '../task-menu/task-menu.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        TaskListItemModule,
        InfiniteScrollModule,
        TaskMenuModule
    ],
    declarations: [
        TaskListComponent,
    ],
    exports: [
        TaskListComponent,
    ],
    providers: []
})
export class TaskListModule { }
